
import { StringHelper } from "@rivtn/noseur";
import { Utils } from "../../../utils";
import { i18nManager } from "../../../i18n";
import { IHostWebsite, ITournamentEdition, IWebsitePage } from "../../../services";

export type HostPage = keyof IHostWebsite["website_pages"];

export const PAGE_ORDER: HostPage[] = ["HOME", "TOURNAMENTS", "EVENTS", "BLOG", "MERCH", "ABOUT"];

export const DASHBOARD_URL = process.env.REACT_APP_OMNEHOST_DASHBOARD_URL ?? "http://127.0.0.1:3901";

export function pagePath(basePath: string, page: string) {
    return `/${basePath}${page === "HOME" ? "" : "/" + page.toLowerCase()}`;
}

export function visiblePages(website: IHostWebsite): [string, IWebsitePage][] {
    return Utils.entriesInCustomOrder(website.website_pages as any, PAGE_ORDER).filter(([_, pageSettings]) => pageSettings.visible);
}

export function isPageVisible(website: IHostWebsite, page: HostPage) {
    return !!website.website_pages?.[page]?.visible;
}

export function hostLogo(website: IHostWebsite): string | undefined {
    return website.host.logo_url ?? website.media?.LOGO?.[0];
}

export function hostBanner(website: IHostWebsite): string | undefined {
    const banners = website.media?.BANNER;
    if (!banners?.length) return undefined;
    return banners[website.extra_data?.media?.BANNER?.active ?? 0] ?? banners[0];
}

// "[ 01 ]" style index used across the template
export function indexTag(index: number) {
    return `[ ${String(index + 1).padStart(2, "0")} ]`;
}

export function stripMarkdown(content: string, length = 140) {
    const text = (content ?? "").replace(/[#*_>`~[\]()!-]/g, "").replace(/\s+/g, " ").trim();
    return text.length > length ? text.substring(0, length).trim() + "…" : text;
}

export function prizePools(edition?: ITournamentEdition): string[] {
    return Object.entries(edition?.meta?.price_pool_amounts ?? {})
        .map(([currency, amount]) => `${i18nManager.queryCountryCurrency(currency, "currency_code", "currency_sign")} ${StringHelper.toPresentableMoneyValue(amount)}`);
}

export function editionDates(edition?: ITournamentEdition): string | undefined {
    const { tournament_start_date: start, tournament_end_date: end } = edition?.dates ?? {};
    if (start && end) return Utils.rangeDate(new Date(start), new Date(end));
    if (start) return Utils.fineDateShort(new Date(start));
    return undefined;
}
